import request from '../utils/request.js'
import qs from 'qs';
// 新建问诊
export function saveAsk(data) {
    return request({
        url: '/user-service/ewechat/ask/submit',
        method: 'post',
        data,
        headers: {
            "content-type": "application/json",
        },
    })
}

export function getAskCache(data) {
    return request({
        url: '/user-service/ewechat/ask/getStaging',
        method: 'post',
        data,
        headers: {
            "content-type": "application/json",
        },
    })
}

export function saveAskCache(data) {
    return request({
        url: '/user-service/ewechat/ask/staging',
        method: 'post',
        data,
        headers: {
            "content-type": "application/json",
        },
    })
}

export function removeAskCache(data) {
    return request({
        url: '/user-service/ewechat/ask/delStaging',
        method: 'post',
        data,
        headers: {
            "content-type": "application/json",
        },
    })
}

export function checkUserIdCard(data) {
    return request({
        url: '/hospital-infrastructure-service/realname/api/check',
        method: 'post',
        data:qs.stringify(data),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
}

export function getDoctorPrescriptionByaskNo(params) {
    return request({
        url: '/doctor-service/prescription/getDoctorPrescriptionByaskNo',
        method: 'get',
        params
    })
}

export function getCheckFirstAsk(params) {
    return request({
        url: `/user-service/member/checkFirstAsk/${params.memberId}`,
        method: 'get',
        params
    })
}